import {
  Group,
  GroupTitle,
  ReferenceListField,
  useFieldLabel,
} from "ra-friendsofbabba";
import { useInput } from "react-admin";

import React from "react";
import { UserField } from "../../component/field";
import UserMenuButton from "../buttons/UserMenuButton";
import UserStatusField from "./UserStatusField";
import ResearcherProjectField from "./ResearcherProjectField";

const UsersField = ({ disabled, ...props }) => {
  useInput({ ...props });
  const fieldLabel = useFieldLabel({ ...props });

  return (
    <Group {...props} wrapper>
      <GroupTitle
        title={fieldLabel(props?.source)}
        subTitle={fieldLabel(`${props?.source}.help`)}
      />
      <ReferenceListField
        {...props}
        perPage={10}
        addLabel={false}
        reference="substitutive-declarations-users"
        target="substitutive_declaration_id"
        create={false}
        modify={false}
        remove={false}
        sorry={fieldLabel("substitutive-declarations-users.sorry")}
      >
        <UserField
          source="user.name"
          label={fieldLabel("user_id")}
          sortable={false}
        />
        <ResearcherProjectField
          source="project"
          label={fieldLabel("project")}
          sortable={false}
        />
        <UserStatusField label={fieldLabel("status")} sortable={false} />
        <UserMenuButton disabled={disabled} />
      </ReferenceListField>
    </Group>
  );
};
export default UsersField;
